//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MIcon, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Components/Toolkit/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import {IMsalContext} from '@azure/msal-react';
import CrewListControl from '../Components/CrewListControl';
import {CrewContactData} from '../Api/ControllerTypes/WorkMailTypes';
import MSpacer from '../Toolkit/Components/Controls/Spacer';

//endregion

/** */
type Props = {
    onSelectionChange: (newSelection: CrewContactData | CrewContactData[] | undefined) => void;
    crewTypes: number[];
    msalContext: IMsalContext;
    onDialogClose: (cancelled: boolean) => void;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    pageTitle: string;
    parentId: string;
    promptText: string;
    selection?: CrewContactData | CrewContactData[] | undefined;
}

/** */
class CrewSelectionDialog extends MComponent<Props, State> {

    private CheckIcon: MIcon = {name: 'pi pi-check-square', color: 'mcolor-info'};

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.cancel_Click = this.cancel_Click.bind(this);
        this.isOkDisabled = this.isOkDisabled.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            pageTitle: 'Sub Contractor Selection',
            parentId: '',
            promptText: '',
            selection: undefined
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(promptText: string, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.promptText = promptText;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        if(this.props.onDialogClose !== null) {
            this.props.onDialogClose!(false);
        }
        this.safeSetState(s => s.visible = false);
    }

    private cancel_Click() {
        if(this.props.onDialogClose !== null) {
            this.props.onDialogClose!(true);
        }
        this.safeSetState(s => s.visible = false);
    }

    private onSelectionChange(newSelection: CrewContactData | CrewContactData[] | undefined) {
        this.safeSetState(draft => draft.selection = newSelection);
        this.props.onSelectionChange(newSelection);
    }

    private isOkDisabled() {
        if(Array.isArray(this.state.selection)) {
            return this.state.selection.length === 0;
        }

        return this.state.selection === undefined;
    }

    private getDialogTemplate(): ReactNode {
        return (
            <React.Fragment>
                <div className="formgrid grid">
                    <div style={{width: "50vw", marginBottom: "20px"}}>
                        <p>{this.state.promptText}</p>
                    </div>
                    <div className="col-12 md:col-12" style={{width: "50vw"}}>
                        <CrewListControl parentId={this.state.parentId}
                                         selectionOnly={false}
                                         msalContext={this.props.msalContext}
                                         onSelectionChange={this.onSelectionChange}
                                         crewTypes={this.props.crewTypes}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={this.isOkDisabled}
                         onClick={this.ok_Click}/>
                <MSpacer/>
                <MButton label="Cancel"
                         color="primary"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.cancel_Click}/>
            </div>
        );
    }
    /** */
    public render(): ReactElement {

        return (
            <Dialog title={this.state.pageTitle}
                    content={this.getDialogTemplate()}
                    icon={this.CheckIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}
                    style={{width: "60vw"}}
            />
        );
    }
}

export default CrewSelectionDialog;
